import React, { useState } from 'react';

import { useGetTopPiratedChannelsQuery } from '../../redux/apis/analyticsManagement/aMIptvAnalyticsApiSlice';
import BarChart from '../other/charts/BarChart';
import ComponentLoader from '../other/ComponentLoader';
import { Card, CardBody } from '../other/card/card';

const PERIOD_LABELS = {
  current_month: 'Current Month',
  current_year: 'Current Year',
  previous_year: 'Previous Year',
};
const PERIOD_OPTIONS = ['current_month', 'current_year', 'previous_year'];
const TOP_PIRATED_CHANNELS_CHART_HEIGHT = 500;

const IPTVTopPiratedChannels = () => {
  const [selectedPeriod, setSelectedPeriod] = useState('current_month');

  const { data, isLoading, isFetching, isError, error } = useGetTopPiratedChannelsQuery({ period: selectedPeriod }, {
    refetchOnMountOrArgChange: true,
  });
  const safeData = data && typeof data === 'object' ? data : {};
  const hasData = Object.keys(safeData).length > 0;
  const getPeriodButtonClass = period =>
    `btn btn-sm bg-transparent ${selectedPeriod === period ? 'text-theme border-theme' : 'text-body-secondary border-secondary opacity-75'}`;

  return (
    <div className='row g-2 mt-1'>
      <div className='col-12'>
        <Card className='mb-0'>
          <CardBody className='relative p-0'>
            {isError ? (
              <div className='absolute inset-0 d-flex items-center justify-center p-3 text-danger small bg-white bg-opacity-75'>
                Failed to load.
                {error?.data?.message ? ` ${error.data.message}` : ''}
              </div>
            ) : null}

            <div className='p-4 d-flex flex-column gap-2'>
              <div className='d-flex fw-bold small'>Top Pirated Channels (Global View)</div>
              <div className='d-flex flex-wrap align-items-center gap-2'>
                {PERIOD_OPTIONS.map(period => (
                  <button
                    key={period}
                    type='button'
                    className={getPeriodButtonClass(period)}
                    disabled={isFetching}
                    onClick={() => setSelectedPeriod(period)}
                  >
                    {PERIOD_LABELS[period]}
                  </button>
                ))}
              </div>
            </div>
            <div className='p-4 pt-0'>
              <div className='small text-body-secondary'>
                <div className='mt-2 position-relative' style={{ minHeight: TOP_PIRATED_CHANNELS_CHART_HEIGHT }}>
                  {isFetching ? <ComponentLoader /> : null}
                  {hasData ? (
                    <BarChart data={safeData} height={`${TOP_PIRATED_CHANNELS_CHART_HEIGHT}px`} />
                  ) : !isLoading ? (
                    <div
                      className='d-flex align-items-center justify-content-center text-center px-2'
                      style={{ minHeight: TOP_PIRATED_CHANNELS_CHART_HEIGHT }}
                    >
                      No top pirated channels data found for this period.
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default IPTVTopPiratedChannels;
